import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { IInvoiceWithCustomer } from './statistics'

interface AvgItemCountChartProps {
  invoices: IInvoiceWithCustomer[]
}

export default function AvgItemCountChart({
  invoices,
}: AvgItemCountChartProps) {
  const data = React.useMemo(() => {
    if (!Array.isArray(invoices) || invoices.length === 0) return []

    const monthMap: {
      [month: string]: { totalItems: number; invoiceCount: number }
    } = {}
    invoices.forEach((invoice) => {
      const createdAt = invoice.createdAt
      if (!createdAt) return
      const month = String(createdAt).slice(0, 7) // 'YYYY-MM'
      let itemCount = 0
      if (Array.isArray(invoice.invoiceProducts)) {
        itemCount = invoice.invoiceProducts.reduce((sum: number, prod) => {
          const qty = Number(prod.productQty)
          return sum + (isNaN(qty) ? 0 : qty)
        }, 0)
      }
      if (!monthMap[month]) {
        monthMap[month] = { totalItems: 0, invoiceCount: 0 }
      }
      monthMap[month].totalItems += itemCount
      monthMap[month].invoiceCount += 1
    })
    return Object.entries(monthMap)
      .map(([month, { totalItems, invoiceCount }]) => ({
        month,
        avgItemCount: invoiceCount > 0 ? totalItems / invoiceCount : 0,
      }))
      .sort((a, b) => a.month.localeCompare(b.month))
  }, [invoices])

  return (
    <div>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis allowDecimals={true} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="avgItemCount"
            stroke="#ff9800"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
